import { TFilter } from '../../types/filters';
import { TAvailableModifierActions } from '../../types/modifier';
import { useContext } from '../useContext';
import { isSearchResultsTooltipOpen } from './isSearchResultsTooltipOpen';

interface IParameters {
  filterKey: TFilter;
  actions: TAvailableModifierActions[];
}

interface IAdvancedFiltersParameters {
  filterKey: 'advancedFilters';
}

type TParameters = IParameters | IAdvancedFiltersParameters;

export function useSearchResultsTooltipOpen(parameters: TParameters) {
  const { lastAppliedModifiers, isTooltipAvailable, openedFilters } = useContext();

  return (
    isTooltipAvailable &&
    isSearchResultsTooltipOpen({
      openedFilters,
      modifiers: lastAppliedModifiers,
      ...parameters,
    })
  );
}
